import PropTypes from "prop-types";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

/** Card có thanh tiêu đề màu nổi phía trên như các bảng của Material Dashboard. */
function PageCard({ title, subtitle, color, actions, children, noPadding }) {
  return (
    <Card sx={{ mt: 4, height: "calc(100% - 32px)" }}>
      <MDBox
        mx={2}
        mt={-3}
        py={2}
        px={2}
        variant="gradient"
        bgColor={color}
        borderRadius="lg"
        coloredShadow={color}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={1}
      >
        <MDBox>
          <MDTypography variant="h6" color="white">
            {title}
          </MDTypography>
          {subtitle && (
            <MDTypography variant="caption" color="white" opacity={0.8}>
              {subtitle}
            </MDTypography>
          )}
        </MDBox>
        {actions && (
          <MDBox display="flex" gap={1} flexWrap="wrap" alignItems="center">
            {actions}
          </MDBox>
        )}
      </MDBox>
      <MDBox p={noPadding ? 0 : 2} pt={noPadding ? 1 : 3}>
        {children}
      </MDBox>
    </Card>
  );
}

PageCard.defaultProps = {
  subtitle: null,
  color: "info",
  actions: null,
  noPadding: false,
};

PageCard.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
  noPadding: PropTypes.bool,
};

export default PageCard;
